<template>
  <div class="class-history-student">
    <div class="to-rule-setting-nav" v-if="!editMode && app.permission.op('become_history')">
      <van-button plain type="primary" square round @click="editMode = true">批量转曾就读</van-button>
    </div>
    <div class="wrapper">
      <div class="stu" v-for="item in result" :key="item.studentId" @click="clickHandler(item)">
        <div class="left flex-center">
          <div v-if="editMode">
            <van-checkbox
              class="tag"
              :value="item.checked"
              icon-size="var(--fs-lg)"
              :disabled="item.student.status !== 1"
            />
          </div>
          <div class="ava flex-center">
            {{ item.studentName.slice(-2) }}
            <div
              v-if="item.photo"
              class="ava-img"
              :style="`background-image: url('${item.photo.url}');`"
            ></div>
          </div>
        </div>
        <div class="right flex-between van-hairline--bottom">
          <div class="name">
            <div style="display: flex;align-items: center;">
              {{ item.studentName }}
              <span 
                class="tag" 
                :class="{
                  'is-history': item.student.status == 6 || item.student.status == 99,
                  'is-stop': item.student.status == 7,
                  'is-unpaid': item.student.status == 0 }"
              >
                {{ studentsStatusDict[item.student.status] }}
              </span>
            </div>
            <p>出班日期 {{ item.outDate | formatDatetime('yyyy-MM-dd') }}</p>
          </div>
          <!-- <van-icon name="arrow" size="18" color="var(--g6)" /> -->
          <div
            class="icon-wrap"
            @click.stop="handStudent(item)"
            v-if="
              app.permission.op(
                'transfer_class_student || transfer_curriculum_student || remove_class_student'
              ) && !editMode
            "
          >
            <van-icon name="weapp-nav" size="var(--fs-lg)" color="var(--g6)" />
          </div>
        </div>
      </div>
      <empty-page :show="result.length === 0 && !loading" tips="班级暂无历史学员~" />
    </div>
    <div class="footer" v-if="editMode">
      <div class="choosed-status">
        <div class="checked-nav" :class="{ 'all-checked': allChecked }">
          <van-checkbox v-model="allChecked" icon-size="var(--fs-lg)" />全选
        </div>
      </div>
      <van-button
        class="ccbtn"
        square
        round
        @click="cancelBatch"
        style="margin-right: calc(var(--gap) * 12)"
      >
        返回
      </van-button>
      <van-button class="cnbtn" square round block type="primary" @click="doMultiEdit">
        批量转曾就读({{ choosedList.length }}/{{ result.length }})
      </van-button>
    </div>

    <!-- 加入班级、调整出入班日期 -->
    <van-action-sheet
      v-model="showAs02"
      cancel-text="取消"
      :round="false"
      :close-on-click-action="true"
    >
      <div class="as-wrap">
        <div
          v-if="app.permission.op('add_class_student')"
          class="as-item van-hairline--bottom"
          @click="toIntoClass"
        >
          加入班级
        </div>
      </div>
      <div class="as-wrap">
        <div
          class="as-item van-hairline--bottom"
          @click="toInOutClassLog"
        >
          调整出入班日期
        </div>
      </div>
    </van-action-sheet>
    <!-- 选择学员入班日期 -->
    <van-popup  
      position="bottom" 
      round 
      v-model="chooseDatePopup"
      :safe-area-inset-bottom="true"
      closeable
      >
      <div class="popup-body">
        <div class="popup-title">请选择学员入班日期</div>
        <div 
          class="van-hairline--bottom" 
          style="padding-bottom: calc(var(--gap) * 14);margin: 0 calc(var(--gap) * 16)">
          学员将加入入班日期后的班级排课
        </div>
        <van-cell @click="chooseDate">
          <template #title>
            <div class="cell-title">
              入班日期
            </div>
          </template>
          <div class="cell-value" :class="{placeholder: !inDate}">
            <span>
              {{inDate?inDate: '请选择'}}
            </span>
            <van-icon name="arrow"></van-icon>
          </div>
        </van-cell>
        <div style="background-color: var(--g1);height: calc(var(--w) * 11);"></div>
      </div>
      <div class="popup-footer">
        <van-button type="primary" block square round @click="confirmInDate">确定</van-button>
      </div>
    </van-popup>
    <!-- 转曾就读提醒 -->
    <van-dialog 
      getContainer="body"
      v-model="showToOldConfirm" 
      title="转为曾就读学员提醒" 
      class="batch-student-to-old-dialog"
      @confirm="transferStudentToOld"
      confirm-button-text="确定"
      show-cancel-button>
      <div class="batch-student-to-old-dialog-contain">
        <div style="text-align: center;">确认是否将已选{{choosedList.length}}个学员转为曾就读学员？</div>
        <div class="tips-contain">
          <!-- <p class="desc">{{transferCourseStrs}}</p> -->
          <p>转为曾就读学员后：</p>
          <ol>
            <!-- <li>启用的上课卡将自动停用；</li> -->
            <li>学员会自动移出所在班级，并移出“上课时间”为今天及之后的未点名排课</li>
            <li>重新购买后将自动恢复为在读学员</li>
          </ol>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import emptyPage from '@teacher/components/empty-page.vue';

export default {
  components:{
    emptyPage
  },
  inject: ['studentsStatusDict'],
  data () {
    return {
      pageTitle: "历史学员",
      result: [],
      loading: false,
      classId: this.$vxRoute.query.cid,
      showAs02: false,
      chooseDatePopup: false,
      inDate: '',
      classInfo: {},
      editMode: false,
      showToOldConfirm: false,
    }
  },
  computed: {
    canChoosedList() {
      return this.result.filter(v => v.student.status === 1);
    },
    choosedList() {
      return this.result.filter(v => v.checked);
    },
    allChecked: {
      get() {
        return (
          this.canChoosedList.length === this.choosedList.length && this.choosedList.length !== 0
        );
      },
      set(v) {
        this.canChoosedList.forEach(item => {
          this.$set(item, 'checked', v);
        });
      },
    },
  },
  methods: {
    clickHandler(item) {
      if (this.editMode) {
        item.student.status === 1 && this.$set(item, 'checked', !item.checked);
      } else {
        this.$router.push(`/baseStudentDetails?id=${item.studentId}`);
      }
    },
    // 点击单个学员的操作图标
    handStudent(stu) {
      this.hander = stu;
      this.showAs02 = true;
    },
    async gtClassStuList() {
      return this.$api.classStudentFindClassStudent({
        classId: this.classId, 
        inOut: 2
      }).then(res => {
        if (res.code == 200) {
          this.result = res.data;
          return res;
        }
        if (res.code > 60000) {
          app.http.tipErr(res.msg || '网络异常，请稍后重试');
          return res;
        }
        return res;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    chooseDate() {
      app.x3.picker
        .datetime({
          type: 'date',
          'min-date': new Date('2020/01/01'),
          'max-date': new Date(),
          value: this.inDate ? new Date(this.inDate.replace(/\-/g, '/')) : new Date(),
        })
        .then(res => {
          this.inDate = app.tool.date.filterDate(res);
        });
    },
    toIntoClass () {
      this.showAs02 = false;
      this.chooseDatePopup = true;     
      this.inDate = app.tool.date.filterDate(new Date()); 
    },
    toInOutClassLog () {
      let sid = this.hander.studentId;
      let cid = this.classInfo.id;
      let sName = this.hander.studentName;
      let cName = this.classInfo.className;
      this.$router.push(`/inOutClassLog?sid=${sid}&cid=${cid}&sName=${sName}&cName=${cName}`)
    },
    confirmInDate () {
      if (!this.inDate) {
        vant.Toast("请选择日期");
        return false;
      }
      this.confirm(0)    
    },
    // 提交添加更多学员
    async confirm(oversold) {
      this.showLoading();
      let res = await this.$api.intoClass({
        campusId: this.classInfo.campusId,
        classId: this.classInfo.id,
        studentIds: [this.hander.studentId],
        priceItemId: this.classInfo.priceItemId,
        oversold: oversold || 0,
        inDate: this.inDate,
      });
      this.$toast.clear();
      if (res.code === 200) {
        vant.Toast.success("添加成功");
        app.vue.$emit("refresh-classStudentList");
        this.gtClassStuList();
        this.chooseDatePopup = false; 
        return false;
      }

      if (res.code == 830000024) {
        vant.Dialog.alert({
          title: '学员入班失败',
          allowHtml: true,
          message: `以下学员在所选入班日期已在班或在所选日期后存在入班记录，无法入班。请前往学员详情查看学员出入班记录。<br><span style="color: var(--g8);">${res.msg}</span>`,
          confirmButtonText: '确认',
           messageAlign: "left",
        });
        return false;
      }

      if (res.code == 790000001 && !oversold) {
        vant.Dialog.confirm({
          title: "提示",
          message: "班级学员已满，是否确认继续添加学员",
        })
          .then(()=> this.confirm(1))
          .catch(()=>{
            console.log('取消添加学员');
          });
        return false;
      }
      if (res.code > 60000) this.$toast.fail(res.msg);
    },
    async getclassInfo() {
      let res = await this.$api.getClassInfoVo({
        classId: this.classId,
      });

      this.classInfo = res.data;
    },
    async getData(){
      this.showLoading();
      this.loading = true;
      let res;
      await this.getclassInfo();
      this.$toast.clear();
      try {
        res = await this.gtClassStuList();
        res.code === 200 && this.$toast.clear();
      } catch (err) {
        console.log(err)
      }
      this.loading = false;
    },
    cancelBatch() {
      if (this.$vxRoute.query.editMode) {
        this.$router.back();        
      } else {
        this.editMode = false;
        this.choosedList.forEach(item => this.$set(item, 'checked', false));
      }
    },
    doMultiEdit() {
      if (this.choosedList.length == 0) {
        vant.Toast('请选择学员');
        return;
      }
      this.showToOldConfirm = true;
    },
    // 转为曾就读学员
    transferStudentToOld () {
      this.showLoading();
      this.$api.batchBecomeHistory({
        studentIds: this.choosedList.map(v=> v.studentId),
      }).then(async (res) => {
        vant.Toast.clear();
        if (res.code === 200) {
          if (res.data.allSuccess) {
            this.$toast.success('操作成功');
            await this.gtClassStuList();
            if (this.canChoosedList.length == 0 && this.$vxRoute.query.editMode) {
              this.$router.back();
            }
          } else {
            this.getData();
            let html = `<div style="text-align:left">此次批量转${res.data.totalCount}个学员为曾就读，成功<span style="color: var(--c2);">${res.data.successCount}</span>个，失败<span style="color: var(--c3);">${res.data.failCount}</span>个，失败学员名单如下：</div>`
            if (res.data.failInfoList && res.data.failInfoList.length){
              html += res.data.failInfoList.map(item=>{
                return `<div style="text-align:left;margin-top:10px;">${item.studentName}（${item.parentPhone}）：${item.msg}</div>`
              }).join('');
            }
            vant.Dialog.alert({
              title: '提示',
              allowHtml: true,
              message: html,
              confirmButtonText: '我知道了'
            });
          }
        }
        if (res.code > 60000) {                
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  async created () {
    this.editMode = this.$vxRoute.query.editMode ? true : false;
    this.getData();
    this.$onBus('refresh-history-classStudentList', this.getData);
  }
}
</script>
<style lang="scss" scoped>
.class-history-student{
  display: flex;
  flex-direction: column;
  .to-rule-setting-nav{
    margin: calc(var(--gap) * 12) 0;
    padding: 0 calc(var(--gap) * 16) 0;
    text-align: right;
    >button{
      padding: 0 calc(var(--gap) * 12);
      height: calc(var(--w) * 30);
    }
  }
  .wrapper {
    flex: 1;
    overflow-y: auto;
    position: relative;
    .stu {
      position: relative;
      display: flex;
      background: var(--white);
      justify-content: space-between;
      .left {
        padding-left: calc(var(--gap) * 16);
        .tag {
          margin-right: 10px;
        }
        .ava {
          position: relative;
          width: calc(var(--w) * 40);
          height: calc(var(--w) * 40);
          color: var(--white);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          background-color: var(--c1);
          border-radius: 50%;
          overflow: hidden;
          flex:0 0 auto;
          .ava-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
  
      .right {
        flex: 1 1 auto;
        margin-left: calc(var(--gap) * 10);
        padding: calc(var(--gap) * 16) calc(var(--gap) * 50) calc(var(--gap) * 16) 0;
        position: relative;
        .name {
          color: var(--g8);
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
          .tag {
            margin-left: calc(var(--gap) * 8);
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
            padding: 0 calc(var(--gap) * 4);
            border-radius: calc(var(--radius-base) * 0.5);
            color: var(--c1);
            background-color: rgba(var(--c1-rgb), 0.12);
            &.is-history {
              color: var(--g6);
              background-color: rgba(var(--g6-rgb), 0.12);
            }
            &.is-unpaid  {
              color: var(--c4);
              background-color: rgba(var(--c4-rgb), 0.12);
            }
            &.is-stop {
              color: var(--c3);
              background-color: rgba(var(--c3-rgb), 0.12);
            }
          }
          > p {
            margin: calc(var(--gap) * 2) 0 0;
            color: var(--g6);
            font-size: var(--fs-sm);
            line-height: var(--lh-sm);
          }
        }
        .icon-wrap {
          position: absolute;
          right: calc(var(--gap) * 16);
          top: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          padding: calc(var(--gap) * 10);
          margin-right: calc(var(--gap) * -10);
        }
      }
    }
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }
    .ccbtn {
      flex: 2;
    }
    .cnbtn {
      flex: 5;
    }
    .choosed-status {
      flex: 1;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);

      .checked-nav {
        margin-right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        color: var(--g6);
        > div {
          margin-right: calc(var(--gap) * 4);
        }
        &.all-checked {
          color: var(--g8);
        }
      }
    }
  }
}
.as-wrap {
  .as-item {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: var(--fs-lg);
  }
}
.popup-body{
  text-align: center;
  color: var(--g6);
  .popup-title{
    color: var(--g8);
    margin: calc(var(--gap) * 13) 0 calc(var(--gap) * 4);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: var(--bold);
  }
  .cell-title{
    text-align: left;
    color: var(--g7);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
  }
  .cell-value{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &:not(.placeholder){      
      color: var(--g7);
    }
    i{
      margin-left: calc(var(--gap) * 8);
    }
  }
}
.popup-footer {
  background-color: #fff;
  padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
}
</style>
<style lang="scss">
.batch-student-to-old-dialog-contain{
  margin: calc(var(--gap) * 10) calc(var(--gap) * 24) 0;
  color: var(--g6);
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  .tips-contain{
    max-height: calc(var(--w) * 300);
    padding: calc(var(--gap) * 16);
    margin: calc(var(--gap) * 10) 0 calc(var(--gap) * 24);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background: var(--g1);
    border-radius: var(--radius-base);
    overflow-y: auto;
    .desc {
      color: var(--c3);
    }
    li,p{
      margin: calc(var(--gap) * 8) 0;
    }
    p:first-child{
      margin-top: 0;
    }
    li:last-child{
      margin-bottom: 0;
    }
  }
  .tips-contain>ol{
    padding-inline-start: calc(var(--gap) * 16);
    list-style: decimal;
    >li{
      padding-left: calc(var(--gap) * 6);
    }
  }
}
</style>